var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 3000 3000",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1500,
    cy: 1500,
    fill: "#ff4949",
    r: 1500,
    "data-original": "#4ba198",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2299.09 2089.12h-1598.18c-4.84 0-9.54-.64-14-1.84l548.18-548.19 207.25 207.25c31.79 31.8 83.55 31.79 115.32-.01l207.26-207.25 548.2 548.19c-4.48 1.2-9.18 1.85-14.03 1.85zm-1650.2-39.24c-1.35-4.72-2.07-9.71-2.07-14.87 0-104.83-2.59-1065.72 1.5-1082.7l549.07 549.07zm1153.73-548.5 549.07-549.06c4.1 17.03 1.5 977.81 1.5 1082.69 0 5.15-.72 10.13-2.07 14.85zm-1117.85-588.04c5.1-1.6 10.52-2.46 16.14-2.46h1598.18c5.63 0 11.06.87 16.17 2.47l-795.31 795.29c-10.55 10.58-29.33 10.58-39.88 0l-795.29-795.3z",
    fill: "#ffffff",
    "data-original": "#ffffff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.6d9e4d88ac9c1574cf30add89722de5d.svg";
export { ForwardRef as ReactComponent };